import { render, staticRenderFns } from "./CoursesMenu.vue?vue&type=template&id=470b6581&"
import script from "./CoursesMenu.vue?vue&type=script&lang=js&"
export * from "./CoursesMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports